import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { DefaultImage } from '../../shared';
import styles from './Logos.module.css';
import OrgaLogo from 'assets/images/logos/orga-logo.svg';
import { getSafeImageSource } from '../../../utils';
import classNames from 'classnames';
import { LayoutCluster } from '../../../components/layouts/LayoutCluster';
const orgaLogo = getSafeImageSource(OrgaLogo);
function Logos(t0) {
  const $ = _c(23);
  const {
    logoSrc: logoSrc_,
    logoAlt: logoAlt_,
    logoSecondarySrc,
    logoSecondaryAlt,
    Image: t1,
    height,
    className,
    width
  } = t0;
  const Image = t1 === undefined ? DefaultImage : t1;
  const logoIsEmpty = !logoSrc_;
  const logoSrc = logoSrc_ || orgaLogo;
  const logoAlt = logoAlt_ || "betterplace";
  let t2;
  if ($[0] !== height || $[1] !== logoIsEmpty) {
    t2 = height ? {
      height: logoIsEmpty ? height - 4 : height
    } : undefined;
    $[0] = height;
    $[1] = logoIsEmpty;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const heightStyle = t2;
  let t3;
  if ($[3] !== className) {
    t3 = classNames(styles.logoContainer, className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== Image || $[6] !== height || $[7] !== heightStyle || $[8] !== logoAlt || $[9] !== logoSrc || $[10] !== width) {
    t4 = <Image src={logoSrc} alt={logoAlt} height={height} width={width} className={styles.logo} style={heightStyle} />;
    $[5] = Image;
    $[6] = height;
    $[7] = heightStyle;
    $[8] = logoAlt;
    $[9] = logoSrc;
    $[10] = width;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== Image || $[13] !== height || $[14] !== heightStyle || $[15] !== logoSecondaryAlt || $[16] !== logoSecondarySrc || $[17] !== width) {
    t5 = logoSecondarySrc && <Image src={logoSecondarySrc} width={width} height={height} alt={logoSecondaryAlt} className={styles.logo} style={heightStyle} />;
    $[12] = Image;
    $[13] = height;
    $[14] = heightStyle;
    $[15] = logoSecondaryAlt;
    $[16] = logoSecondarySrc;
    $[17] = width;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <LayoutCluster className={t3}>{t4}{t5}</LayoutCluster>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}
export default Logos;